import { SvgIcon, SvgIconProps } from "@mui/material";
import { StepIconProps } from "@mui/material/StepIcon";

export const ArrowBackButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M19 12H5M5 12L11 6M5 12L11 18" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const CreateNowCardIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "15", height: "14", fill: "none" }}
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M1.66675 7.00033H13.3334M13.3334 7.00033L7.50008 1.16699M13.3334 7.00033L7.50008 12.8337"
        stroke="#008B07"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ProvideOverallStepperIcon = ({ active, completed, ...props }: StepIconProps) => {
  return (
    <SvgIcon component="svg" inheritViewBox style={{ width: "30px", height: "30px" }} viewBox="0 0 30 30" fill="none">
      <circle cx="15" cy="15" r="14.5" transform="rotate(-90 15 15)" fill="white" stroke="#008B07" />
      <path
        d="M16.6666 14.167H11.6666M13.3333 17.5003H11.6666M18.3333 10.8337H11.6666M21.6666 10.667V19.3337C21.6666 20.7338 21.6666 21.4339 21.3941 21.9686C21.1544 22.439 20.772 22.8215 20.3016 23.0612C19.7668 23.3337 19.0667 23.3337 17.6666 23.3337H12.3333C10.9331 23.3337 10.2331 23.3337 9.69828 23.0612C9.22787 22.8215 8.84542 22.439 8.60574 21.9686C8.33325 21.4339 8.33325 20.7338 8.33325 19.3337V10.667C8.33325 9.26686 8.33325 8.5668 8.60574 8.03202C8.84542 7.56161 9.22787 7.17916 9.69828 6.93948C10.2331 6.66699 10.9331 6.66699 12.3333 6.66699H17.6666C19.0667 6.66699 19.7668 6.66699 20.3016 6.93948C20.772 7.17916 21.1544 7.56161 21.3941 8.03202C21.6666 8.5668 21.6666 9.26686 21.6666 10.667Z"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};

export const CompleteIdentityStepperIcon = ({ active, completed, ...props }: StepIconProps) => {
  return (
    <SvgIcon component="svg" inheritViewBox style={{ width: "31px", height: "30px" }} viewBox="0 0 31 30" fill="none">
      <circle cx="15.5" cy="15" r="14.5" transform="rotate(-90 15.5 15)" fill="white" stroke="#008B07" />
      <path
        d="M17.1666 6.8916V10.3337C17.1666 10.8004 17.1666 11.0338 17.2574 11.212C17.3373 11.3688 17.4648 11.4963 17.6216 11.5762C17.7999 11.6671 18.0332 11.6671 18.4999 11.6671H21.942M12.9999 18.3337L14.6666 20.0003L18.4166 16.2503M17.1666 6.66699H12.8333C11.4331 6.66699 10.7331 6.66699 10.1983 6.93948C9.72787 7.17916 9.34542 7.56161 9.10574 8.03202C8.83325 8.5668 8.83325 9.26686 8.83325 10.667V19.3337C8.83325 20.7338 8.83325 21.4339 9.10574 21.9686C9.34542 22.439 9.72787 22.8215 10.1983 23.0612C10.7331 23.3337 11.4331 23.3337 12.8333 23.3337H18.1666C19.5667 23.3337 20.2668 23.3337 20.8016 23.0612C21.272 22.8215 21.6544 22.439 21.8941 21.9686C22.1666 21.4339 22.1666 20.7338 22.1666 19.3337V11.667L17.1666 6.66699Z"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};

export const AcceptJobsStepperIcon = ({ active, completed, ...props }: StepIconProps) => {
  return (
    <SvgIcon component="svg" inheritViewBox style={{ width: "30px", height: "30px" }} viewBox="0 0 30 30">
      <circle cx="15" cy="15" r="12.5" fill="#008B07" />
      <path
        d="M20.625 11.4305L19.507 10.3125L13.2685 16.5451L10.8124 14.089L9.6875 15.2061L13.2685 18.787L20.625 11.4305Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const UnSelectedChipIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "10", height: "10", fill: "none" }}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path d="M5 1V9" stroke="#707070" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M9 5L1 5" stroke="#707070" strokeWidth="1.5" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const SelectedChipIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "10", height: "8", fill: "none" }}
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
    >
      <path d="M1 3.61872L3.90909 6.66634L9 1.33301" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const FinalServiceCostIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_32648_212166)">
        <path
          d="M12 0C5.3832 0 0 5.38327 0 12.0001C0 18.6169 5.3832 24 12 24C18.6168 24 24 18.6169 24 12.0001C24 5.38327 18.6168 0 12 0ZM12 21.8182C6.58618 21.8182 2.18182 17.4138 2.18182 12.0001C2.18182 6.58633 6.58618 2.18182 12 2.18182C17.4138 2.18182 21.8182 6.58633 21.8182 12.0001C21.8182 17.4138 17.4137 21.8182 12 21.8182Z"
          fill="#008B07"
        />
        <path
          d="M11.9997 5.09082C11.1978 5.09082 10.5454 5.74362 10.5454 6.54602C10.5454 7.34769 11.1978 7.99991 11.9997 7.99991C12.8016 7.99991 13.4539 7.34769 13.4539 6.54602C13.4539 5.74362 12.8016 5.09082 11.9997 5.09082ZM11.9998 10.1817C11.3973 10.1817 10.9089 10.6702 10.9089 11.2726V17.8181C10.9089 18.4206 11.3973 18.909 11.9998 18.909C12.6023 18.909 13.0907 18.4206 13.0907 17.8181V11.2726C13.0907 10.6702 12.6023 10.1817 11.9998 10.1817Z"
          fill="#008B07"
        />
      </g>
      <defs>
        <clipPath id="clip0_32648_212166">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const ServiceAmountWarningIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <circle cx="10" cy="10" r="7" fill="#008B07" stroke="#008B07" />
      <path d="M10 9.16699V13.3337" stroke="white" strokeWidth="1.4" strokeLinecap="round" />
      <mask id="path-3-inside-1_32720_25761" fill="white">
        <ellipse cx="9.99984" cy="6.66634" rx="0.833333" ry="0.833333" />
      </mask>
      <ellipse cx="9.99984" cy="6.66634" rx="0.833333" ry="0.833333" fill="white" />
      <path
        d="M10.8332 6.66634H9.83317C9.83317 6.57429 9.90779 6.49967 9.99984 6.49967V7.49967V8.49967C11.0124 8.49967 11.8332 7.67886 11.8332 6.66634H10.8332ZM9.99984 7.49967V6.49967C10.0919 6.49967 10.1665 6.57429 10.1665 6.66634H9.1665H8.1665C8.1665 7.67886 8.98731 8.49967 9.99984 8.49967V7.49967ZM9.1665 6.66634H10.1665C10.1665 6.75839 10.0919 6.83301 9.99984 6.83301V5.83301V4.83301C8.98731 4.83301 8.1665 5.65382 8.1665 6.66634H9.1665ZM9.99984 5.83301V6.83301C9.90779 6.83301 9.83317 6.75839 9.83317 6.66634H10.8332H11.8332C11.8332 5.65382 11.0124 4.83301 9.99984 4.83301V5.83301Z"
        fill="white"
        mask="url(#path-3-inside-1_32720_25761)"
      />
    </SvgIcon>
  );
};

export const OpenVideoAccordionIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#98A2B3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CloseVideoAccordionIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#98A2B3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const SelectServiceBannerImageIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      style={{ width: "44", height: "44", fill: "none" }}
    >
      <g filter="url(#filter0_d_32648_210022)">
        <rect x="2" y="1" width="40" height="40" rx="8" fill="white" shapeRendering="crispEdges" />
        <rect x="2.5" y="1.5" width="39" height="39" rx="7.5" stroke="#E4E7EC" shapeRendering="crispEdges" />
        <path
          d="M18.6667 24.3333L22 21M22 21L25.3334 24.3333M22 21V28.5M28.6667 24.9524C29.6846 24.1117 30.3334 22.8399 30.3334 21.4167C30.3334 18.8854 28.2813 16.8333 25.75 16.8333C25.5679 16.8333 25.3976 16.7383 25.3051 16.5814C24.2184 14.7374 22.212 13.5 19.9167 13.5C16.4649 13.5 13.6667 16.2982 13.6667 19.75C13.6667 21.4718 14.3629 23.0309 15.4891 24.1613"
          stroke="#475467"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_32648_210022"
          x="0"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_32648_210022" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_32648_210022" result="shape" />
        </filter>
      </defs>
    </SvgIcon>
  );
};

export const CloseSelectServiceBannerModalButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={{ width: "24", height: "24", fill: "none" }}
    >
      <path d="M18 6L6 18M6 6L18 18" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const DeleteSelectServiceBannerButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      style={{ width: "36", height: "36", fill: "none" }}
    >
      <rect width="36" height="36" rx="8" fill="white" />
      <path
        d="M21.3333 13.0003V12.3337C21.3333 11.4002 21.3333 10.9335 21.1517 10.577C20.9919 10.2634 20.7369 10.0084 20.4233 9.84865C20.0668 9.66699 19.6001 9.66699 18.6667 9.66699H17.3333C16.3999 9.66699 15.9332 9.66699 15.5767 9.84865C15.2631 10.0084 15.0081 10.2634 14.8483 10.577C14.6667 10.9335 14.6667 11.4002 14.6667 12.3337V13.0003M16.3333 17.5837V21.7503M19.6667 17.5837V21.7503M10.5 13.0003H25.5M23.8333 13.0003V22.3337C23.8333 23.7338 23.8333 24.4339 23.5608 24.9686C23.3212 25.439 22.9387 25.8215 22.4683 26.0612C21.9335 26.3337 21.2335 26.3337 19.8333 26.3337H16.1667C14.7665 26.3337 14.0665 26.3337 13.5317 26.0612C13.0613 25.8215 12.6788 25.439 12.4392 24.9686C12.1667 24.4339 12.1667 23.7338 12.1667 22.3337V13.0003"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
